import { LOGOS } from "./logoManifest";

const ITEMS = [
  { slug: "northvolt", name: "Northvolt" },
  { slug: "pacgroup", name: "The PAC Group" },
  { slug: "google", name: "Google" },
  { slug: "muller", name: "Müller" },
  { slug: "amazon", name: "Amazon" },
  { slug: "pepsico", name: "PepsiCo" },
  { slug: "kelloggs", name: "Kellogg's" },
  { slug: "mands", name: "M&S" },
  { slug: "dairycrest", name: "Dairy Crest" },
  { slug: "aryzta", name: "Aryzta" },
  { slug: "pmgroup", name: "PM Group" },
  { slug: "nhs", name: "NHS" },
  { slug: "bovishomes", name: "Bovis Homes" },
  { slug: "crown", name: "Crown (Bevcan)" },
  { slug: "imtech", name: "Imtech Meica" },
  { slug: "tsl", name: "TSL" },
  { slug: "virtua", name: "Virtua" },
  { slug: "lorein", name: "Lorein Engineering" },
];

const Wordmark = ({ name }) => (
  <span className="whitespace-nowrap font-heading text-base font-bold tracking-tight text-brand-charcoal/45 transition-colors duration-300 hover:text-brand-navy md:text-lg">
    {name}
  </span>
);

const RibbonTrack = ({ ariaHidden }) => (
  <div className="marquee-track" aria-hidden={ariaHidden || undefined}>
    {ITEMS.map((item) => (
      <span key={item.slug} className="flex items-center">
        {LOGOS[item.slug] ? (
          <img
            src={LOGOS[item.slug]}
            alt={item.name}
            title={item.name}
            className="ribbon-logo"
            width={110}
            height={26}
            loading="lazy"
            decoding="async"
            data-testid={`ribbon-logo-${item.slug}`}
          />
        ) : (
          <Wordmark name={item.name} />
        )}
        <span
          className="mx-6 h-1.5 w-1.5 shrink-0 rounded-full bg-brand-green/40 md:mx-9"
          aria-hidden="true"
        />
      </span>
    ))}
  </div>
);

export default function Ribbon() {
  return (
    <div
      className="marquee border-y border-brand-line bg-white py-7"
      data-testid="experience-marquee"
    >
      <RibbonTrack />
      <RibbonTrack ariaHidden />
    </div>
  );
}
